import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { CarouselItem, VideoCarouselItem, setImages } from 'services/viewVehicleSlice/viewVehicleSlice';
import { useExteriorSectionData } from '../components/VehicleSections/hooks/useExteriorSection';
import { useLevel1SectionData } from '../components/VehicleSections/hooks/useLevel1Section';
import { useDashImages } from '../components/VehicleSections/hooks/useDashImages';
import { useOBDImages } from '../components/VehicleSections/hooks/useOBDImages';
import { useTireImages } from '../components/VehicleSections/hooks/useTireImages';
import { useExteriorVideo } from '../components/VehicleSections/hooks/useExteriorVideo';

export const useInitImages = () => {
  const dispatch = useDispatch();

  const { images: exteriorImages } = useExteriorSectionData('exterior');
  const { images: rawTiresImages } = useExteriorSectionData('tires');
  const tiresImages = useTireImages();
  const { images: interiorImages } = useLevel1SectionData('interior_questions');
  const { images: underHoodImages } = useLevel1SectionData('under_hood');
  const { smogImages, vinImage, plateImage } = useOBDImages();
  const dashImages = useDashImages();
  const video = useExteriorVideo();

  useEffect(() => {
    const exteriorNonDamaged = exteriorImages.filter(img => !img.is_damaged);
    const exteriorDamaged = [...exteriorImages, ...rawTiresImages].filter(img => img.is_damaged);
    const videoItems: VideoCarouselItem[] = video
      ? [{ id: 'exterior.video', url: video, type: 'exterior.video' }]
      : [];
    const interiorSliced = interiorImages.slice(1);
    const interiorNonDamaged = interiorSliced.filter(img => !img.is_damaged);
    const interiorDamaged = interiorSliced.filter(img => img.is_damaged);
    const tiresWheels = tiresImages.filter(img => !img.is_damaged);

    const combined: CarouselItem[] = [
      ...exteriorNonDamaged,
      ...exteriorDamaged,
      ...videoItems,
      ...interiorNonDamaged,
      ...interiorDamaged,
      ...underHoodImages,
      ...smogImages,
      ...dashImages,
      ...(vinImage ? [vinImage] : []),
      ...(plateImage ? [plateImage] : []),
      ...tiresWheels,
    ].filter(item => !!item.url);

    dispatch(setImages(combined));
  }, [
    exteriorImages, rawTiresImages, tiresImages, interiorImages,
    underHoodImages, smogImages, dashImages, vinImage, plateImage, video
  ]);
};
